import styled from "styled-components";

import { ExitReservationStyledProps as Props } from "./ExitReservation.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const ExitReservationStyled = styled.div<Props>`
  justify-content: center;
  background-color: var(--palette-dark-blue-s13-l11);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 6.4rem 4rem;
  border-radius: 1.6rem;

  @media (max-width: ${tablet - 1}px) {
    padding: 0;
  }

  .ExitReservation {
    &__header {
      @media (max-width: ${tablet - 1}px) {
        width: auto;
        padding: 2.4rem;
      }
    }

    &__title {
      color: var(--palette-white);
      font-size: 2.4rem;
      font-weight: 600;
      padding-top: 1.6rem;
      padding-bottom: 0.8rem;
    }

    &__description {
      color: var(--palette-white);
      font-size: 1.6rem;
      white-space: break-spaces;
    }

    &__buttons {
      align-self: center;
      padding: 3.2rem;

      &__top {
        color: var(--palette-black);
        font-weight: 600;
        font-size: 1.6rem;
        padding: 1.6rem 2.4rem;
        min-width: 100%;
      }

      &__bottom {
        margin-top: 1.6rem;
        color: var(--palette-white);
        font-weight: 600;
        font-size: 1.6rem;
        background-color: var(--palette-mid-blue-s15-l20);
        border: 0.2rem solid var(--palette-mid-blue-s15-l20);
        padding: 1.6rem 2.4rem;
        min-width: 100%;
      }

      @media (max-width: ${tablet - 1}px) {
        width: auto;
      }
    }

    &__error {
      font-size: 1.6rem;
      color: var(--palette-red-s95-l65);
      padding: 1.2rem 0;
    }
  }
`;

export default ExitReservationStyled;
